export class PendingOperationWrapper {
  private operationPromise?: Promise<any>;

  pending = false;
  success = false;
  error = false;
  errorMessage = '';
  technicalError = '';

  handle(operationPromise: Promise<any>) {
    this.clear();

    this.operationPromise = operationPromise;
    this.pending = true;
    this.operationPromise.then(() => {
      if (this.operationPromise != operationPromise) return;
      
      this.pending = false;
      this.success = true;
    })
    .catch(err => {
      if (this.operationPromise != operationPromise) return;

      this.pending = false;
      this.error = true;
      this.errorMessage = err.message || '';
      this.technicalError = err.originalMessage || '';
    });
  }

  clear() {
    this.pending = false;
    this.success = false;
    this.error = false;
    this.errorMessage = '';
    this.technicalError = '';
    this.operationPromise = undefined;
  }
}